<template>
  <div class="pa-3 ma-3">
    <v-alert-dialog ref="alert"></v-alert-dialog>

    <!-- Crear/Editar -->
    <v-dialog max-width="65%" v-model="dialogAddEdit" persistent>
      <v-card>
        <v-card-title>
          {{ editedItem.id_contratacion_regimen === null ? "Crear" : "Editar" }} Régimen de Contratación
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12">
              <v-text-field
                v-model="editedItem.nombre"
                label="Nombre"
                outlined
                dense
                hide-details
              />
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green" text @click="closeDialogAddEdit">Cancelar</v-btn>
          <v-btn color="red" text @click="saveDialogAddEdit" :loading="loadingSave">Guardar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Eliminar -->
    <v-dialog max-width="65%" v-model="dialogDelete" persistent>
      <v-card>
        <v-card-title>Eliminar Régimen de Contratación</v-card-title>
        <v-card-text>
          ¿Está seguro de que desea eliminar el régimen "{{ editedItem.nombre }}"?
          Esta acción es permanente y no se puede revertir.
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green" text @click="closeDialogDelete">Cancelar</v-btn>
          <v-btn color="red" text @click="saveDialogDelete" :loading="loadingDelete">Eliminar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-row>
      <v-col cols="12">
        <v-btn color="primary" @click="openDialogAddEdit(null)">
          Crear Régimen de Contratación
        </v-btn>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12">
        <v-data-table
          :items="items"
          :headers="headers"
          :loading="loading"
          item-key="id_contratacion_regimen"
        >
          <template v-slot:[`item.actions`]="{ item }">
            <v-icon small class="mr-2" @click="openDialogAddEdit(item)">mdi-pencil</v-icon>
            <v-icon small class="mr-2" @click="openDialogDelete(item)">mdi-delete</v-icon>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import axios from 'axios'
import VAlertDialog from '@/components/VAlertDialog.vue'

export default {
  components: { VAlertDialog },
  data: () => ({
    dialogAddEdit: false,
    dialogDelete: false,
    loading: false,
    loadingSave: false,
    loadingDelete: false,
    items: [],
    headers: [
      { text: 'Régimen de Contratación', value: 'nombre', align: 'center', width: '90%' },
      { text: 'Acciones', value: 'actions', align: 'center', width: '10%' }
    ],
    editedItem: {
      id_contratacion_regimen: null,
      nombre: ''
    },
    defaultEditedItem: {
      id_contratacion_regimen: null,
      nombre: ''
    }
  }),
  mounted () {
    this.getItems()
  },
  methods: {
    getItems () {
      this.loading = true
      axios
        .get('/RHCatalogos/ListarContratacionRegimenes')
        .then(res => { this.items = res.data })
        .catch(err => { console.error(err) })
        .finally(() => { this.loading = false })
    },
    openDialogAddEdit (editItem = null) {
      this.editedItem = Object.assign({}, editItem ?? this.defaultEditedItem)
      this.dialogAddEdit = true
    },
    closeDialogAddEdit () {
      this.editedItem = Object.assign({}, this.defaultEditedItem)
      this.dialogAddEdit = false
    },
    saveDialogAddEdit () {
      // Validación solo de nombre
      if (!this.editedItem.nombre || this.editedItem.nombre.length > 256) {
        this.$refs.alert.setMessage('', 'Debe ingresar un Nombre entre 1 y 256 caracteres')
        this.$refs.alert.open()
        return
      }

      this.loadingSave = true
      const isCreate = this.editedItem.id_contratacion_regimen === null

      axios({
        method: isCreate ? 'POST' : 'PUT',
        url: isCreate
          ? '/RHCatalogos/CrearContratacionRegimen'
          : `/RHCatalogos/EditarContratacionRegimen/${this.editedItem.id_contratacion_regimen}`,
        data: {
          nombre: this.editedItem.nombre
        }
      })
        .then(() => {
          this.getItems()
          this.closeDialogAddEdit()
        })
        .catch(err => { console.error(err) })
        .finally(() => { this.loadingSave = false })
    },
    openDialogDelete (editItem) {
      this.editedItem = Object.assign({}, editItem)
      this.dialogDelete = true
    },
    closeDialogDelete () {
      this.editedItem = Object.assign({}, this.defaultEditedItem)
      this.dialogDelete = false
    },
    saveDialogDelete () {
      this.loadingDelete = true
      axios
        .delete(`/RHCatalogos/EliminarContratacionRegimen/${this.editedItem.id_contratacion_regimen}`)
        .then(() => {
          this.closeDialogDelete()
          this.getItems()
        })
        .catch(err => { console.error(err) })
        .finally(() => { this.loadingDelete = false })
    }
  }
}
</script>
